import axios from './interceptor';

const ANNOUNCEMENT_URL = `${process.env.REACT_APP_BASE_URL}/announcements`;

export function createAnnouncement(obj) {
    return axios.post(ANNOUNCEMENT_URL, obj);
}

export function updateAnnouncement(id, obj) {
    return axios.put(`${ANNOUNCEMENT_URL}/${id}`, obj);
}

export function deleteAnnouncement(id) {
    return axios.delete(`${ANNOUNCEMENT_URL}/${id}`);
}

export function getAnnouncements() {
    return axios.get(ANNOUNCEMENT_URL);
}
